import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.LossCodeCategory.Delete.IRequest;
type Response = Api.Core.LossCodeCategory.Delete.IResponse;
type Headers = Api.Core.LossCodeCategory.Delete.IHeaders;
const url = '/api/Claims/LossCodeCategory/:id';
export default async function lossCodeCategoryDeleteApi(id: number): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.delete,
    url: createPathFromRoute(url, { id }),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
